import React from 'react'
import classnames from 'classnames'
import { node, string, oneOfType, arrayOf } from 'prop-types'
import './StackableCollapsibleCard.scss'

const StackableCardWrapper = ({ className, children }) => (
    <div className={classnames('stackable card', className)}>
        {children}
    </div>
)

StackableCardWrapper.propTypes = {
    className: string,
    children: oneOfType([arrayOf(node), node]).isRequired
}

export default StackableCardWrapper